import { HEADER_V3 } from '@photosi/rn-components/headers/header/header.constants';
import { Platform, StyleSheet } from 'react-native';
import { Background } from 'src/theme-v2/background';
import { Stroke } from 'src/theme-v2/stroke';
import { neutrals, brand, text, alert, stroke } from 'src/theme/colors';
import { MOBILE_MAIN_HEADER_V3_HEIGHT } from './HeaderV3.constants';

export const styleDesktop = StyleSheet.create({
  headerContainer: {
    paddingHorizontal: 24,
    paddingVertical: 14,
    alignContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    width: '100%',
    height: HEADER_V3.height.desktop,
    zIndex: 1,
  },
  separator: {
    height: 24,
    borderLeftWidth: 1,
    borderColor: Stroke.StrokeColor.StrokeColorNeutral,
  },
  leftElements: {
    gap: 0,
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
  leftActions: {
    gap: 16,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  leftAction: {
    gap: 8,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 4,
    justifyContent: 'flex-start',
  },
  leftActionIcon: {
    width: 22,
    height: 22,
    padding: 2,
  },
  leftActionText: {
    fontWeight: 700,
    fontSize: 16,
    lineHeight: 24,
    color: brand.main.water,
  },
  centerElements: {
    gap: 16,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
  },
  rightElements: {
    gap: 16,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flex: 1,
  },
  totalProducts: {
    gap: 8,
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: neutrals.white,
    paddingVertical: 4,
    paddingHorizontal: 8,
    borderRadius: 12,
  },
  totalProductsText: {
    fontWeight: 400,
    fontSize: 12,
    lineHeight: 14,
    color: neutrals.neutralGrays.coal,
  },
  totalProductsChip: {
    borderRadius: 7,
    paddingHorizontal: 10,
    paddingVertical: 2,
    backgroundColor: brand.main.water,
  },
  iconInfo: {
    width: 14,
    height: 14,
  },
  originalPrice: {
    fontWeight: 400,
    fontSize: 12,
    lineHeight: 16,
    color: neutrals.neutralGrays.coal,
    textDecorationLine: 'line-through',
  },
  buttonCart: {
    height: 44,
    minHeight: 'auto',
    paddingHorizontal: 20,
    backgroundColor: text.color.interactive,
  },
  buttonCartDisabled: {
    backgroundColor: neutrals.neutralGrays.dust,
    paddingHorizontal: 20,
    paddingVertical: 7,
    borderRadius: 24,
  },
  buttonCartDisabledText: {
    color: neutrals.neutralGrays.ash,
    cursor: 'auto',
  },
  buttonChat: {
    width: 38,
    height: 38,
    borderRadius: 24,
    shadowColor: neutrals.black,
    shadowOffset: { width: 9, height: 4 },
    shadowOpacity: 0.08,
    shadowRadius: 20,
  },
  buttonChatGradient: {
    width: 38,
    height: 38,
    borderRadius: 24,
    justifyContent: 'center',
    alignItems: 'center',
  },
  iconChat: {
    width: 18,
    height: 18,
  },
  totalProductsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: neutrals.neutralGrays.crystal,
    paddingVertical: 8,
    paddingHorizontal: 12,
    gap: 12,
    borderRadius: 55,
  },
  priceContainer: {
    gap: 4,
    flexDirection: 'row',
    alignItems: 'center',
  },
  estimatedPrice: {
    fontWeight: 700,
    fontSize: 14,
    lineHeight: 16,
  },
  hoverText: {
    color: neutrals.black,
    fontSize: 12,
    lineHeight: 15.6, //12* 130%
    fontWeight: '700',
    ...Platform.select({
      web: {
        whiteSpace: 'nowrap' as any,
      },
    }),
  },
});

export const styleMobile = StyleSheet.create({
  headerContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 100,
    ...Background.BackgroundColorBlur,
  },
  mainHeader: {
    paddingHorizontal: 16,
    paddingVertical: 15,
    alignContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    width: '100%',
    height: MOBILE_MAIN_HEADER_V3_HEIGHT,
  },
  rightElements: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flex: 1,
    gap: 8,
  },
  leftElements: {
    gap: 8,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flex: 1,
  },
  leftAction: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  leftActionIcon: {
    width: 22,
    height: 22,
  },
  iconBadge: {
    width: 10,
    height: 10,
    borderRadius: 8,
    borderWidth: 2,
    backgroundColor: alert.alertRed,
    borderColor: neutrals.white,
    position: 'absolute',
    right: -2,
    top: -2,
  },
  separator: {
    height: 24,
    borderLeftWidth: 1,
    borderColor: stroke.strokeColorBrand,
  },
});
